// extracted by mini-css-extract-plugin
export default {"base":"ErrorMessage_base__cqKsR"};